import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Menu from './components/menu';
import Footer from './components/footer';
import Home from '../src/pages/Home';
import ContentInterface from './pages/Articles_content/Content_interface_API.jsx';
import Contact from './pages/Contact';
import ScrollButton from './components/ScrollButton';
import ScrollToTop from './components/ScrollTotop';
import RiskWarning from './components/RiskWarning';
import { LoginProvider } from './components/logIncontext.jsx';
import { NotificationsProvider } from './components/Notifications.jsx';
import NotificationToasts from './components/NotificationToasts.jsx';

function NotFoundRedirect() {
  const { lang } = useParams(); // Captura el idioma desde la URL
  return <Navigate to={`/${lang}/`} replace />;
}

function App() {
  return (
    <LoginProvider>
      <HelmetProvider>
        <NotificationsProvider>
          <NotificationToasts position="bottom-left" duration={6000} max={4} />
          <Router>
            <ScrollToTop />
            {/* Advertencia de riesgo obligatoria: fija en la parte superior de cada
                página y siempre visible al hacer scroll. Empuja el menú fijo y el
                contenido hacia abajo mediante la variable --risk-warning-height.
                Se muestra en todos los entornos EXCEPTO Saint Vincent (SVG). */}
            <RiskWarning />
            {/* Main layout */}
            <Menu />
            <div
              className="content bg-white dark:bg-primaryBg"
              style={{ paddingTop: 'var(--risk-warning-height, 0px)' }}
            >
              <Routes>
                {/* Redirect root to /en */}
                <Route path="/" element={<Navigate to="/en/" replace />} />
                <Route path="/:lang/" element={<Home />} />
                <Route path="/:lang/:category/:article/" element={<ContentInterface />} />
                <Route path="/:lang/:category/:subcategory/:article" element={<ContentInterface />} />
                <Route path="/:lang/:category/:subcategory/:nestedSubcategory/:article" element={<ContentInterface />} />
              <Route path="/:lang/contact/" element={<Contact />} />
                {/* Catch-all route for undefined URLs */}
                <Route path="/:lang/*" element={<NotFoundRedirect />} />
              </Routes>
            </div>
            <ScrollButton />
            <Footer />
          </Router>
        </NotificationsProvider>
      </HelmetProvider>
    </LoginProvider>
  );
}

export default App;
